import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import {
  catchError,
  debounceTime,
  filter,
  map,
  mergeMap,
  pluck,
  startWith,
  switchMap,
} from 'rxjs/operators'

import * as UserSelectors from 'modules/user/selectors'

import * as actions from './actions'
import { api } from './api'

const createProfile = (action$, state$) => {
  return action$.pipe(
    ofType(actions.createProfile.toString()),
    mergeMap(() => {
      const userId = UserSelectors.getUserId(state$.value)
      return api.createProfile(userId).pipe(
        map(actions.createProfileSuccess),
        startWith(actions.createProfilePending()),
        catchError(() => of(actions.createProfileFailed()))
      )
    })
  )
}

const updateProfile = (action$, state$) => {
  return action$.pipe(
    ofType(actions.updateProfile.toString()),
    pluck('payload'),
    mergeMap((operations) => {
      const userId = UserSelectors.getUserId(state$.value)
      return api.updateProfile(userId, operations).pipe(
        map(actions.updateProfileSuccess),
        startWith(actions.updateProfilePending()),
        catchError(() => of(actions.updateProfileFailed()))
      )
    })
  )
}

const fetchProfile = (action$, state$) => {
  return action$.pipe(
    ofType(actions.fetchProfile.toString()),
    pluck('payload'),
    mergeMap(() => {
      const userId = UserSelectors.getUserId(state$.value)
      return api.fetchProfile(userId).pipe(
        map((res) => actions.fetchProfileSuccess(res.data)),
        startWith(actions.fetchProfilePending()),
        catchError(() => of(actions.fetchProfileFailed()))
      )
    })
  )
}

const checkUniqueHandle = (action$) => {
  return action$.pipe(
    ofType(actions.checkUniqueHandle.toString()),
    debounceTime(200),
    pluck('payload'),
    mergeMap((handle) => {
      return api.checkUniqueHandle(handle).pipe(
        map(actions.checkUniqueHandleFailed),
        catchError((error) => {
          if (error?.response?.status === 404) {
            return of(actions.checkUniqueHandleSuccess())
          }
          return of(actions.checkUniqueHandleFailed())
        })
      )
    })
  )
}

const uploadCoverPhoto = (action$) => {
  return action$.pipe(
    ofType(actions.uploadCoverPhoto.toString()),
    pluck('payload'),
    switchMap((file) => {
      return api.upload(file).pipe(
        map(({ url }) => actions.uploadCoverPhotoSuccess(url)),
        startWith(actions.uploadCoverPhotoPending()),
        catchError(() => of(actions.uploadCoverPhotoFailed()))
      )
    })
  )
}

const initCalendarUserProfile = (action$, state$) => {
  return action$.pipe(
    ofType(actions.createProfileSuccess.toString()),
    filter(() => UserSelectors.isCalendarSeatOnboarding(state$.value)),
    mergeMap(() => {
      const userId = UserSelectors.getUserId(state$.value)
      return api
        .updateProfile(userId, [
          {
            operation: 'set',
            value: true,
            property: 'calendarOnlyStatus',
          },
        ])
        .pipe(
          map(actions.updateProfileSuccess),
          startWith(actions.updateProfilePending()),
          catchError(() => of(actions.updateProfileFailed()))
        )
    })
  )
}

export const epic = combineEpics(
  createProfile,
  updateProfile,
  fetchProfile,
  checkUniqueHandle,
  uploadCoverPhoto,
  initCalendarUserProfile
)
